/**
 * SharedConfig.paths - common CDN asset path constants
 */
const CDN_ROOT = 'https://d3e54v103j8qbb.cloudfront.net/';
const UPLOADS_CDN_ROOT = 'https://daks2k3a4ib2z.cloudfront.net/';
const PLACEHOLDER_ROOT = CDN_ROOT + 'img/';

const EXAMPLE_IMG_NAME = 'image-placeholder.svg';
const EXAMPLE_BG_NAME = 'background-image.svg';
const EXAMPLE_THUMB_NAME = 'placeholder-thumb.svg';
const EXAMPLE_PREBUILTS_V2_BG_NAME =
  'prebuilts-hero-placeholder.ddc7100a8c.svg';

const STATIC_ROOT = CDN_ROOT + 'static/';

type Paths = {
  EXAMPLE_IMG_ID: string;
  EXAMPLE_IMG_NAME: string;
  EXAMPLE_IMG_URL: string;
  EXAMPLE_IMG_FILESIZE: number;
  EXAMPLE_IMG_WIDTH_HEIGHT: number;
  EXAMPLE_BG_ID: string;
  EXAMPLE_BG_NAME: string;
  EXAMPLE_BG_URL: string;
  EXAMPLE_THUMB_ID: string;
  EXAMPLE_THUMB_NAME: string;
  EXAMPLE_THUMB_URL: string;
  EXAMPLE_PREBUILTS_V2_BG_ID: string;
  EXAMPLE_PREBUILTS_V2_BG_NAME: string;
  EXAMPLE_PREBUILTS_V2_BG_URL: string;
  PAGE_NOT_FOUND_ICON_ID: string;
  PAGE_NOT_FOUND_ICON_NAME: string;
  PAGE_NOT_FOUND_ICON_URL: string;
  PASSWORD_PAGE_ICON_ID: string;
  PASSWORD_PAGE_ICON_NAME: string;
  PASSWORD_PAGE_ICON_URL: string;
  YOUTUBE_PLACEHOLDER_ID: string;
  YOUTUBE_PLACEHOLDER_NAME: string;
  YOUTUBE_PLACEHOLDER_URL: string;
  CUSTOM_CHECKBOX_CHECK_ID: string;
  CUSTOM_CHECKBOX_CHECK_NAME: string;
  CUSTOM_CHECKBOX_CHECK_URL: string;
  UPLOADS_CDN_ROOT: string;
  GENERAL_SAMPLE_IMG_PATH: string;
  PEOPLE_SAMPLE_IMG_PATH: string;
  AI_PLACEHOLDER_IMG_URL: string;
};

export const paths: Paths = {
  // Placeholder inline image
  EXAMPLE_IMG_ID: 'example_img',
  EXAMPLE_IMG_NAME,
  EXAMPLE_IMG_URL: PLACEHOLDER_ROOT + EXAMPLE_IMG_NAME,
  EXAMPLE_IMG_WIDTH_HEIGHT: 150,
  EXAMPLE_IMG_FILESIZE: 2063,

  // Placeholder background image
  EXAMPLE_BG_ID: 'example_bg',
  EXAMPLE_BG_NAME,
  EXAMPLE_BG_URL: PLACEHOLDER_ROOT + EXAMPLE_BG_NAME,

  // Placeholder thumbnail image
  EXAMPLE_THUMB_ID: 'example_thumb',
  EXAMPLE_THUMB_NAME,
  EXAMPLE_THUMB_URL: PLACEHOLDER_ROOT + EXAMPLE_THUMB_NAME,

  // Placeholder prebuilt layouts v2 background image
  EXAMPLE_PREBUILTS_V2_BG_ID: 'example_prebuilts_bg',
  EXAMPLE_PREBUILTS_V2_BG_NAME,
  EXAMPLE_PREBUILTS_V2_BG_URL: PLACEHOLDER_ROOT + EXAMPLE_PREBUILTS_V2_BG_NAME,

  PAGE_NOT_FOUND_ICON_ID: 'page_not_found',
  PAGE_NOT_FOUND_ICON_NAME: 'page-not-found.svg',
  PAGE_NOT_FOUND_ICON_URL: STATIC_ROOT + 'page-not-found.211a85e40c.svg',

  PASSWORD_PAGE_ICON_ID: 'password_page_icon',
  PASSWORD_PAGE_ICON_NAME: 'password-page-lock.svg',
  PASSWORD_PAGE_ICON_URL: STATIC_ROOT + 'password-page-lock.832ca8e2c9.svg',

  YOUTUBE_PLACEHOLDER_ID: 'youtube_placeholder',
  YOUTUBE_PLACEHOLDER_NAME: 'youtube-placeholder.svg',
  YOUTUBE_PLACEHOLDER_URL: STATIC_ROOT + 'youtube-placeholder.2b05e7d68d.svg',

  CUSTOM_CHECKBOX_CHECK_ID: 'custom_checkbox_check',
  CUSTOM_CHECKBOX_CHECK_NAME: 'custom-checkbox-check.svg',
  CUSTOM_CHECKBOX_CHECK_URL:
    STATIC_ROOT + 'custom-checkbox-checkmark.589d534424.svg',

  // Should match sslCdn in production.js
  UPLOADS_CDN_ROOT,

  // Sample images
  GENERAL_SAMPLE_IMG_PATH: CDN_ROOT + 'img/generic/image',
  PEOPLE_SAMPLE_IMG_PATH: CDN_ROOT + 'img/people/image',
  AI_PLACEHOLDER_IMG_URL: CDN_ROOT + 'img/ai-placeholder/ai-placeholder.svg',
};

export const DEFAULT_PROFILE_IMAGE: string =
  UPLOADS_CDN_ROOT + 'img/profile-user.png';
export const DEFAULT_OAUTH_APP_IMAGE: string =
  UPLOADS_CDN_ROOT + 'img/integrations.png';
